export class Calendar {
    id: number = -1;
    name: string = '';
    description: string = '';
    colour: string = '';
    createdAt: string = '';
    updatedAt:string = '';
}